import ProjectShareModal from '~/javascripts/components/Project/ShareModal';
import SlackTadaEmoji from '~/images/icons/slack-tada-emoji.png';

const VideoPlayerWithShareModal = ({
  communityName,
  contentfulProjectShareContent,
  countryName,
  peopleServed,
  projectUrl,
  renderShareModal,
  videoUrl,
}) => (
  <div className='video-container cursor-pointer relative w-full overflow-hidden theme-design-system-v1'>
    <div className='w-full h-full'>
      <video autoPlay className='w-full h-full' loop muted playsInline>
        <source src={videoUrl} type='video/mp4' />
      </video>
    </div>
    <div className='share-modal-link-container absolute bg-cw-brand-yellow-500 flex flex-col justify-center items-center py-16 px-8 md-px-12 lg-px-20 rounded-md'>
      <span className='heading-xs pb-10 flex flex-row justify-center items-center'>
        <span className='icon cw-icon-location-outline text-xs pr-2' />
        <span>
          {communityName}, {countryName}
        </span>
      </span>
      {peopleServed && (
        <>
          {' '}
          <span className='people-served-number text-cw-brand-grey-900 heading-3xl'>
            {peopleServed}
          </span>
          <span className='people-served-text text-cw-black italic text-kazimir py-3'>
            people served
          </span>
        </>
      )}
      <a
        className='share-modal-button button bg-cw-white tracking-wide text-cw-black heading-xs'
        href='#project-share-modal'
      >
        <img className='pr-2' src={SlackTadaEmoji} />
        share the good news
      </a>
    </div>
    <div className='text-center absolute bottom-0 flex justify-center items-center bg-cw-black opacity-75 w-full py-2 show-for-medium-up'>
      <span className='text-cw-white italic body-s'>
        This video depicts the power of clean water across the countries where
        we work.
      </span>
    </div>
    {renderShareModal && (
      <ProjectShareModal
        communityName={communityName}
        contentfulProjectShareContent={contentfulProjectShareContent}
        peopleServed={peopleServed}
        projectUrl={projectUrl}
      />
    )}
  </div>
);

export default VideoPlayerWithShareModal;
